import React from 'react';
import { PreviewCarousel } from './PreviewCarousel';
import { SectionHeading } from './SectionHeading';

/** Section 4 — the real Volume 2 pages. */
export function PreviewSection() {
  return <section aria-labelledby="preview-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-20" data-id="element-194" data-mp="28g7oi88n848y">
      <div className="mx-auto max-w-6xl" data-id="element-195" data-mp="23g1uwmitc7o8">
        <SectionHeading id="preview-heading" title="Take a Look Inside 👀" body="Visual teaching resources designed to help you explain, demonstrate and teach brow concepts more clearly." data-id="element-196" data-mp="23hd6v9mewlqf" />
        <div className="mt-12" data-id="element-197" data-mp="1pp6r3on68gri">
          <PreviewCarousel data-id="element-198" data-mp="1ppghveg1iry9" />
        </div>
      </div>
    </section>;
}